"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5 5.5A1.5 1.5 0 0 1 6.5 4h11A1.5 1.5 0 0 1 19 5.5v11a1.5 1.5 0 0 1-1.5 1.5H14v1.5a.5.5 0 0 1-.777.416L12 19.101l-1.223.815A.5.5 0 0 1 10 19.5V18H6.5A1.5 1.5 0 0 1 5 16.5zm9 9.736V17h3.5a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5H10v-1.764a3 3 0 1 1 4 0m-1 .593a3 3 0 0 1-2 0v2.737l.723-.482a.5.5 0 0 1 .554 0l.723.482zm.209-1.235a2 2 0 1 0-2.417-3.187 2 2 0 0 0 2.417 3.187"
  })]
}), 'Certificate');
